export default "__VITE_ASSET__O8J6yGTq__"